import _ from "lodash";
import { List, Message } from "semantic-ui-react";
import React from "react";

export const ServerErrorMessage = ({ error }) => {
  if (!error) return null;

  const errorData = error?.response?.data || 
                   (error.message ? { error: [error.message] } : { error: ["An unexpected error occurred"] });
  const errorList = _.flatten(_.values(errorData)).map((e, i) => (
    <List.Item key={i}>{e}</List.Item>
  ));

  return (
    <Message negative>
      <List bulleted>{errorList}</List>
    </Message>
  );
};
